import React, { useState } from 'react';
import { Grid, Tooltip, Snackbar, IconButton } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles } from '@material-ui/core/styles';
import { Close as CloseIcon, Code as CodeIcon, FileCopy as FileCopyIcon, MailOutline as MailIcon } from '@material-ui/icons';
import { useMutation } from 'react-apollo';

import { SEND_SCRIPT_EMAIL } from '../../../queries/sendMailScript';

import { Toast } from '../../../components/Toast';

import Highlight from 'react-highlight.js'
import "../../../../node_modules/highlight.js/styles/dracula.css";

// components
import DrawerPlacements from '../../../components/DrawerPlacements';
import Widget from '../../../components/Widget/Widget';

const useStyles = makeStyles(theme => ({
  labelScript : {
    display       : 'block',
    fontSize      : 12,
    color         : '#6E6E6E',
    fontWeight    : 400,
    textTransform : 'uppercase',
    marginTop     : 13
  },
  linkCopy : {
    display   : 'block',
    cursor    : 'pointer',
    marginTop : 13,
    textAlign : 'center',
    width     : '100%',
    '& svg'   : {
      width : 15
    }
  },
  sendMail: {
  },
  tagPre : {
    display         : 'initial',
    backgroundColor : '#ccc',
    padding         : 3,
    textTransform   : 'initial',
  }
}));

export default function Scripts({publisherId}) {
  const classes = useStyles();

  const code = `<script async src="//js.adireto.com/adireto.js?id=${publisherId}"></script>`;

  const [open, setOpen] = useState(false);

  const [sendScriptMail] = useMutation(SEND_SCRIPT_EMAIL);
  const handleSendScriptMail = async (publisherId) => {
    try{
      await sendScriptMail({ variables: {publisherId}})
      Toast('Email sent!');
    } catch(error){
      Toast('Failed to send email to owners.', 'error');
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DrawerPlacements headerButton="off" title="Scripts" buttonHead={false} iconButtonAction={<CodeIcon />}>
      <Widget header={false}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <span className={classes.labelScript}>Copy and Paste before tag <pre className={classes.tagPre}>{'</body>'}</pre></span>
          </Grid>
          <Grid item xs={10}>
            <Highlight language="html">
              {code}
            </Highlight>
          </Grid>
          <Grid item xs={1}>
            <CopyToClipboard text={code}
              onCopy={() => setOpen(true)}>
              <Tooltip arrow placement="top" title="Copy script">
                <IconButton color="primary">
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            </CopyToClipboard>
          </Grid>
          <Grid item xs={1}>
          <Tooltip arrow placement="top" title="Send script email">
            <IconButton key="close" aria-label="close" className={classes.sendMail} color="primary" onClick={ () => handleSendScriptMail(publisherId)}>
              <MailIcon />
            </IconButton>
          </Tooltip>
          </Grid>
        </Grid>
      </Widget>

      <Snackbar
        open={open}
        onClose={handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={<span id="message-id">Script copied!</span>}
        action={[
          <IconButton key="close" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </DrawerPlacements>
  );
}